import './App.css';
import NavBar from './components/Navbar';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import Footer from './components/Footer';
import Category from './components/Category'
import About from './components/About';
import Contact from './components/Contact';
import 'react-toastify/dist/ReactToastify.css';
import { ToolsProvider } from './components/ToolsContext.js';
import PrivacyPolicy from './components/PrivacyPolicy.jsx';
import { useEffect } from 'react';
import TermsConditions from './components/TermsConditions.jsx';
import CookiesPolicy from './components/CookiesPolicy.jsx';

function App() {
  // Add this effect to show/hide back to top button
  useEffect(() => {
    const handleScroll = () => {
      const backToTopBtn = document.querySelector('.back-to-top');
      if (backToTopBtn) {
        if (window.scrollY > 300) {
          backToTopBtn.classList.add('show');
        } else {
          backToTopBtn.classList.remove('show');
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <ToolsProvider>
      <Router>
        <div className="App">
          <NavBar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path='/category' element={<Category />} />
            <Route path='/about' element={<About />} />
            <Route path='/contact' element={<Contact />} />
            <Route path='/privacy' element={<PrivacyPolicy />} />
            <Route path='/terms' element={<TermsConditions />} />
            <Route path='/cookies' element={<CookiesPolicy />} />
            <Route path='/*' element={
              <div className='page-not-found'>
                <div className="not-found-content">
                  <h1 className="not-found-code">404</h1>
                  <h3 className="not-found-title">Page Not Found</h3>
                  <p className="not-found-message">Oops! The page you're looking for doesn't exist or has been moved.</p>
                  <button className="not-found-btn" onClick={() => window.location.href = '/'}>
                    <i className="bi bi-house-door me-2"></i>
                    Back to Home
                  </button>
                </div>
              </div>
            } />
          </Routes>
          <Footer />
        </div>
      </Router>
    </ToolsProvider>
  );
}

export default App;
